import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { modificarFumigado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionModificarFumigadoView } from '../components/OperacionModificarFumigadoView'

export const OperacionModificarFumigado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionModificarFumigadoView
        silo={silo}
        aceptar={async ({ producto, observaciones }) => {
          try {
            await modificarFumigado(silo, producto, observaciones)
            closeDialog()
            enqueueSnackbar('Modificado de fumigado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Modificado de fumigado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('MODIFICAR_FUMIGADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
